export default {
    dev: 'https://dq-back.wzfire.com',
    production: 'https://dq-back.wzfire.com'
}
